import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { MenuItemType } from 'antd/lib/menu/hooks/useItems';

import useI18n from '../../common/hooks/useI18n';

export type HeaderDropdownProps = {
  items: MenuItemType[];
  containerId: string;
  buttonHref: string;
  buttonTextKey: string;
  buttonPrimary?: boolean;
};

const HeaderDropdownClient = dynamic(() => import('./headerDropdownClient'), {
  ssr: false,
});

const HeaderDropdown: React.FC<HeaderDropdownProps> = (props) => {
  const i18n = useI18n();

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <>
      <div style={{ display: isMounted ? 'none' : 'block' }}>
        <details>
          <summary>
            <Link href={props.buttonHref} legacyBehavior>
              <a>{i18n.t(props.buttonTextKey)}</a>
            </Link>
          </summary>
          <ul>
            {props.items.map((item) => (
              <li key={item.key}>{item.label}</li>
            ))}
          </ul>
        </details>
      </div>

      <HeaderDropdownClient {...props} />
    </>
  );
};

export default HeaderDropdown;
